<section class="main_section">
  <div class="total-container">
    <!-- Header -->
    <div class="header-section">
      <div class="create-text" *ngIf="!data.edit">Add New Product</div>
      <div class="create-text" *ngIf="data.edit">Update Product</div>
      <div class="close-btn" (click)="closebutton()">
        <img src="../../../assets/images/close.svg" alt="Close" />
      </div>
    </div>

    <div class="body-section">
      <!-- Product Image -->
      <div class="attachment-section">
        <div class="input-label">Product Image</div>

        <div class="profile-img">
          <div *ngIf="nodeAttachements?.length === 0" class="fc_browse">
            <span class="attach-files-span" (click)="fileInput.click()">
              <span class="plus">+</span> Upload
            </span>
          </div>

            <div class="image-box" *ngIf="(nodeAttachements && nodeAttachements.length > 0) && !pageLoader">
            <span class="fc_browse_btn" (click)="fileInput.click()">
              <span class="plus">+</span> Upload
            </span>
          </div>

          <input
            id="vendorImage"
            type="file"
            name="myfile"
            accept="image/jpg,image/jpeg,image/png"
            multiple
            (change)="updateContactImage($event)"
            class="pc-btn"
            #fileInput
          />

          <div class="addedImg" *ngIf="nodeAttachements.length > 0">
            <ng-container *ngFor="let items of nodeAttachements; let i = index">
              <div class="image-container" *ngIf="items.attachmentType === 'IMAGE'">
                <div class="uploadedImg">
                  <img [src]="ds.bypassSecurityTrustUrl(items.url)" alt="" class="given-img" />
                  <div class="delete_button" (click)="delete(i)">
                    <img src="assets/images/master/delete-icon.svg" alt="delete">
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- Product Info -->
      <div class="lead-section content-box">
        <!-- Product Name -->
        <div class="input-box1">
          <div class="input-label">Product Name<sup>*</sup></div>
          <mat-form-field appearance="outline" class="full-width">
            <input
              matInput
              placeholder="Enter Product Name"
              [(ngModel)]="productData.name"
              name="productName"
              required
               maxlength="50"
              (input)="checkProductNameLength()"
            />
          </mat-form-field>

          <div class="error-message" *ngIf="!productData.name">Product Name is required</div>
        </div>
        <div class="error-message" *ngIf="productNameExceeded">
    Product Name cannot exceed 50 characters
     </div>
        <!-- Brief -->
        <div class="input-box1">
          <div class="input-label">Brief</div>
          <textarea
            matInput
            placeholder="Enter brief (max 200 characters)"
            rows="3"
            [(ngModel)]="productData.brief"
            class="text-area-breif"
            maxlength="200"
             (input)="checkBriefLength()"
          ></textarea>
          <div class="char-counter">
         {{ productData.brief?.length || 0 }}/200
         </div>

         <div class="error-message" *ngIf="briefExceeded">
          Brief cannot exceed 200 characters
          </div>
          </div>

        <!-- Description -->
        <div class="input-box1">
          <div class="input-label">Description</div>
          <textarea
            matInput
            placeholder="Enter Description"
            rows="3"
            [(ngModel)]="productData.descriptor.name"
            class="text-area-breif"
          ></textarea>
        </div>
      </div>

      <!-- Pricing Section -->
      <div class="input-label" style="font-size: 16px; margin-left: 20px;">Pricing</div>
      <div class="body-section-1 p-12">
        <div class="invoice-info display" style="align-items: baseline;">
          <!-- Purchase Price -->
         <div class="input-box">
         <div class="input-label">Purchase Price<sup>*</sup></div>
            <mat-form-field class="full-width input_card" appearance="outline">
             <input
            matInput
             type="number"
             placeholder="Enter Purchase Price"
          [(ngModel)]="productData.price.purchasePrice"
         required
           />
           </mat-form-field>
         <div class="error-message" *ngIf="!productData.price.purchasePrice">
               Purchase Price is required
                  </div>
                 </div>

          <!-- Base Price -->
          <div class="input-box">
            <div class="input-label">Base Price<sup>*</sup></div>
            <mat-form-field class="full-width input_card" appearance="outline">
              <input
                matInput
                type="number"
                placeholder="Enter Base Price"
                [(ngModel)]="productData.price.value"
                required
              />
            </mat-form-field>
            <div class="error-message" *ngIf="!productData.price.value">Base Price is required</div>
          </div>

          <!-- Discounted Price -->
          <div class="input-box">
            <div class="input-label">Discounted Price</div>
            <mat-form-field class="full-width input_card" appearance="outline">
              <input
                matInput
                type="number"
                placeholder="Enter Discounted Price"
                [(ngModel)]="productData.price.discountedPrice"
                name="discountedPrice"
              />
            </mat-form-field>
            <div
              class="error-message"
              *ngIf="productData.price.discountedPrice >= productData.price.sellingPrice && productData.price.discountedPrice"
            >
              Discounted Price must be less than Selling Price
            </div>
          </div>

          <!-- Selling Price -->
          <div class="input-box">
            <div class="input-label">Selling Price<sup>*</sup></div>
            <mat-form-field class="full-width input_card" appearance="outline">
              <input
                matInput
                type="number"
                placeholder="Enter Selling Price"
                [(ngModel)]="productData.price.sellingPrice"
                name="sellingPrice"
                required
              />
            </mat-form-field>
            <div class="input-description">Inclusive of Taxes</div>
            <div class="error-message" *ngIf="!productData.price.sellingPrice">
              Selling Price is required
            </div>
          </div>

          <!-- Tax -->
          <div class="input-box full">
            <div class="input-label">Tax %</div>
            <mat-form-field appearance="outline" class="full-width input_card">
              <mat-select [(ngModel)]="selectedTax" (ngModelChange)="changeTax()">
                <mat-option *ngFor="let term of terms" [value]="term.value">
                  {{ term.viewValue }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Sub Industry -->
      <div class="lead-section content-box">
        <div class="input-label">Sub Industry<sup>*</sup></div>
        <mat-form-field class="full-width input_card" appearance="outline">
          <mat-select
            [(ngModel)]="productData.subIndustryId"
            placeholder="--Select a Sub Industry--"
            (ngModelChange)="getCategoryCollectionBySubIndustryId($event)"
            required
          >
            <mat-option *ngFor="let option of ecomIndustry" [value]="option.subIndustryId">
              {{ option.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="error-message" *ngIf="!productData.subIndustryId">
          Sub Industry is required
        </div>
      </div>

      <!-- Category -->
      <div class="input-box-category">
        <div class="input-label">Category<sup>*</sup></div>
        <mat-form-field class="full-width" appearance="outline">
          <mat-select placeholder="--Select a Category--" [(ngModel)]="selectedCategoryId" required>
            <mat-option *ngFor="let Category of categoryList" [value]="Category.categoryId">
              {{ Category.categoryName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="error-message" *ngIf="!selectedCategoryId">Category is required</div>
      </div>

      <!-- Collection -->
      <div class="select-collection-section">
        <div class="input-label">Select Collection</div>
        <div class="selectalls-check" style="margin: 8px 0;">
          <mat-checkbox [(ngModel)]="allCollectionsSelected" (change)="onSelectAllCollection($event)">
            Select All
          </mat-checkbox>
        </div>

        <mat-form-field appearance="outline" class="full-width">
          <mat-select
            multiple
            placeholder="--Select a Collection--"
            [(ngModel)]="selectedCollectionId"
            (ngModelChange)="onCollectionsChange($event)"
          >
            <mat-option *ngFor="let collection of collectionList" [value]="collection.collectionId">
              {{ collection.collectionName | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Footer -->
    <div class="footer-section">
      <div class="cancle-section">
        <button class="cancle" (click)="closebutton()">Cancel</button>
      </div>

      <div class="createCont-section">
        <button
          class="create-contact"
          [disabled]="
            submitLoader ||
            pageLoader ||
            !productData.name ||
            !productData.price.purchasePrice || 
            !productData.price.value ||
            !productData.price.sellingPrice ||
            !productData.subIndustryId ||
            !selectedCategoryId ||
            (productData.price.discountedPrice >= productData.price.sellingPrice &&
              productData.price.discountedPrice)
          "
          (click)="createItem()"
        >
          <span *ngIf="submitLoader"><i class="fas fa-spinner fa-spin"></i>&nbsp;Loading</span>
          <span *ngIf="!submitLoader">{{ data.edit ? 'Update Product' : '+ Add Product' }}</span>
        </button>
      </div>
    </div>
  </div>
</section>
